<template>
  <span class="flex">
    <AppIcon :icon="icon" start />
    <AppLink plain :to="to">
        <slot />
    </AppLink>
  </span>

</template>

<script setup lang="ts">
defineProps<{
  icon: string;
  to: string;
}>();
</script>